var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"xcbdCls"},[_c('div',{staticClass:"iframeBox"},[_c('iframe',{attrs:{"id":"my-iframe","src":"https://share.blnews.com.cn/webDetails/sonPage?id=19072147&tenantId=18&uid=626b575bfe3fc11bc94ed722&groupId=2196673","frameborder":"0"}})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-da555aa6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xcbd.vue
// module id = null
// module chunks = 